import {
  clearImpersonateEmail,
  getImpersonateEmail,
} from "@/lib/storage-utils";
import { useEffect, useState } from "react";

export default function ImpersonationBanner() {
  const [impersonateEmail, setImpersonateEmail] = useState<string | null>(null);

  useEffect(() => {
    setImpersonateEmail(getImpersonateEmail());
  }, []);

  const handleStopImpersonating = () => {
    clearImpersonateEmail();
    window.location.href = "/admin/impersonate";
  };

  if (!impersonateEmail) {
    return null;
  }

  return (
    <div className="bg-red-600 text-white px-4 py-2 flex items-center justify-center gap-4">
      <span className="font-medium">
        Danger: Currently impersonating {impersonateEmail}
      </span>
      <button
        onClick={handleStopImpersonating}
        className="bg-white text-red-600 px-3 py-1 rounded text-sm font-medium hover:bg-red-50 transition-colors"
      >
        Stop Impersonating
      </button>
    </div>
  );
}
